module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"record":{"pod":"Proof of delivery","por":"Proof of return"}},"vi":{"record":{"pod":"Bằng chứng giao hàng","por":"Bằng chứng trả hàng"}}}')
  delete Component.options._Ctor
}
